/** Which canvases the editor may draw, asked of the manifests and never of a list. */

import { canvasesOf } from "../../lib/catalog";
import type { SpaceActivities } from "../../spaces/lib/queries";

/** Every canvas kind this space's added activities declare, sorted so a picker never reorders. */
export function declaredKinds(activities: SpaceActivities): string[] {
  const kinds: string[] = [];
  for (const one of activities.rows) {
    const entry = activities.entryFor(one);
    if (entry === undefined) continue;
    for (const canvas of canvasesOf(entry)) {
      if (!kinds.includes(canvas.kind)) kinds.push(canvas.kind);
    }
  }
  return kinds.sort((left, right) => left.localeCompare(right));
}
